import React, { forwardRef } from "react"
import styled from "styled-components"

interface Props extends React.ComponentProps<"input"> {}

const PlainInput = forwardRef<HTMLInputElement, Props>(({ ...props }, ref) => {
	return <CustomInput {...props} ref={ref} />
})

export default PlainInput

const CustomInput = styled.input`
	outline: none;
	border: none;
	color: inherit;
	font: inherit;
	background-color: unset;
`
